import {
  IncidentState_RequestingReview_getInstance9azcsnvsfz39 as IncidentState_RequestingReview_getInstance,
  IncidentState_Filed_getInstanceg9puzn4wq1pv as IncidentState_Filed_getInstance,
  IncidentState_Resolved_getInstance22hwduixidcb1 as IncidentState_Resolved_getInstance,
  IncidentState_Settled_getInstance1hrwzjvkv7ot8 as IncidentState_Settled_getInstance,
  IncidentState_WorkingOnResolution_getInstance2xzbjm5gfjniq as IncidentState_WorkingOnResolution_getInstance,
  IncidentState_IssueFiled_getInstance1pq0p85oj3ba4 as IncidentState_IssueFiled_getInstance,
  IncidentState_Disputed_getInstance1vczt2g7fznyr as IncidentState_Disputed_getInstance,
} from '../enums.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../supportModels.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_DAYS_getInstance3abv9r3rbwkq3 as DurationUnit_DAYS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { withOptionalCreditlx9k9tf97u9p as withOptionalCredit } from '../completionResponse/CompletionResponse.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../timeFormatting.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var RemedyHandledClass;
function RemedyHandled() {
  if (RemedyHandledClass === VOID) {
    class $ {
      constructor(remedy) {
        this.y9e_1 = remedy;
      }
      z9e(history) {
        return 'Remedy Complete';
      }
      q9e(history) {
        return IncidentState_RequestingReview_getInstance();
      }
      toString() {
        return 'RemedyHandled(remedy=' + this.y9e_1.toString() + ')';
      }
      hashCode() {
        return this.y9e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemedyHandled()))
          return false;
        if (!this.y9e_1.equals(other.y9e_1))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForClass($, 'RemedyHandled', VOID, VOID, [NeedsApproval()]);
    RemedyHandledClass = $;
  }
  return RemedyHandledClass;
}
function resultantStateHubert$state($history, proposal) {
  var tmp;
  if (proposal instanceof Remedy()) {
    tmp = IncidentState_WorkingOnResolution_getInstance();
  } else {
    if (proposal instanceof RequestSiteVisit()) {
      tmp = $history.g8x();
    } else {
      if (proposal instanceof ContractorDispute()) {
        tmp = resultantStateHubert$state($history, proposal.b9f_1);
      } else {
        var tmp1_subject = $history.n8w();
        var tmp_0;
        switch (tmp1_subject == null ? -1 : tmp1_subject.b4_1) {
          case -1:
            tmp_0 = IncidentState_Filed_getInstance();
            break;
          case 0:
          case 1:
            tmp_0 = IncidentState_Resolved_getInstance();
            break;
          case 2:
            tmp_0 = IncidentState_Settled_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
    }
  }
  return tmp;
}
var FileIncidentClass;
function FileIncident() {
  if (FileIncidentClass === VOID) {
    class $ {
      constructor(concern, raiseIssue) {
        raiseIssue = raiseIssue === VOID ? false : raiseIssue;
        this.t9e_1 = concern;
        this.u9e_1 = raiseIssue;
      }
      z9e(history) {
        return this.t9e_1.e9f_1;
      }
      q9e(history) {
        return this.u9e_1 ? IncidentState_IssueFiled_getInstance() : IncidentState_Filed_getInstance();
      }
      f9f(concern, raiseIssue) {
        return new (FileIncident())(concern, raiseIssue);
      }
      g9f(concern, raiseIssue, $super) {
        concern = concern === VOID ? this.t9e_1 : concern;
        raiseIssue = raiseIssue === VOID ? this.u9e_1 : raiseIssue;
        return $super === VOID ? this.f9f(concern, raiseIssue) : $super.f9f.call(this, concern, raiseIssue);
      }
      toString() {
        return 'FileIncident(concern=' + this.t9e_1.toString() + ', raiseIssue=' + this.u9e_1 + ')';
      }
      hashCode() {
        var result = this.t9e_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.u9e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FileIncident()))
          return false;
        if (!this.t9e_1.equals(other.t9e_1))
          return false;
        if (!(this.u9e_1 === other.u9e_1))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForClass($, 'FileIncident', VOID, VOID, [IncidentResponseType()]);
    FileIncidentClass = $;
  }
  return FileIncidentClass;
}
var ClientResponseClass;
function ClientResponse() {
  if (ClientResponseClass === VOID) {
    class $ {
      constructor(fileDispute, proposingResolution) {
        fileDispute = fileDispute === VOID ? false : fileDispute;
        proposingResolution = proposingResolution === VOID ? false : proposingResolution;
        this.v9e_1 = fileDispute;
        this.w9e_1 = proposingResolution;
      }
      z9e(history) {
        var tmp;
        if (this.v9e_1) {
          tmp = 'File Dispute';
        } else {
          if (this.w9e_1) {
            tmp = 'Proposal';
          } else {
            var tmp0_safe_receiver = history.x8w();
            if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f94(), MoreInfo_instance)) {
              tmp = 'Provide Info';
            } else {
              var tmp1_safe_receiver = history.x8w();
              var tmp2_subject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f94();
              var tmp_0;
              var tmp_1;
              if (tmp2_subject instanceof Remedy()) {
                tmp_1 = true;
              } else {
                tmp_1 = tmp2_subject instanceof Credit();
              }
              if (tmp_1) {
                tmp_0 = 'Propose';
              } else {
                tmp_0 = 'Resubmit Issue';
              }
              tmp = tmp_0;
            }
          }
        }
        return tmp;
      }
      q9e(history) {
        return this.v9e_1 ? IncidentState_Disputed_getInstance() : this.w9e_1 ? history.g8x() : history.g8x();
      }
      h9f(fileDispute, proposingResolution) {
        return new (ClientResponse())(fileDispute, proposingResolution);
      }
      toString() {
        return 'ClientResponse(fileDispute=' + this.v9e_1 + ', proposingResolution=' + this.w9e_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.v9e_1);
        result = imul(result, 31) + getBooleanHashCode(this.w9e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientResponse()))
          return false;
        if (!(this.v9e_1 === other.v9e_1))
          return false;
        if (!(this.w9e_1 === other.w9e_1))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForClass($, 'ClientResponse', ClientResponse, VOID, [IncidentResponseType()]);
    ClientResponseClass = $;
  }
  return ClientResponseClass;
}
var NeedsApprovalClass;
function NeedsApproval() {
  if (NeedsApprovalClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'NeedsApproval', VOID, VOID, [IncidentResponseType()]);
    NeedsApprovalClass = $;
  }
  return NeedsApprovalClass;
}
var DisputeResolutionClass;
function DisputeResolution() {
  if (DisputeResolutionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DisputeResolution', VOID, VOID, [NeedsApproval()]);
    DisputeResolutionClass = $;
  }
  return DisputeResolutionClass;
}
var CreditClass;
function Credit() {
  if (CreditClass === VOID) {
    class $ {
      constructor(credit) {
        this.i9f_1 = credit;
      }
      z9e(history) {
        return 'Credit (' + MonetaryValue__toString_impl_xslc77(this.i9f_1) + ')';
      }
      a9f(history) {
        return 'Credit';
      }
      q9e(history) {
        return history.g8x();
      }
      s8z(credit) {
        return new (Credit())(credit);
      }
      toString() {
        return 'Credit(credit=' + MonetaryValue__toString_impl_xslc77(this.i9f_1) + ')';
      }
      hashCode() {
        return MonetaryValue__hashCode_impl_fhcsz2(this.i9f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Credit()))
          return false;
        if (!(this.i9f_1 === other.i9f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Credit', VOID, VOID, [DisputeResolution()]);
    CreditClass = $;
  }
  return CreditClass;
}
var RemedyClass;
function Remedy() {
  if (RemedyClass === VOID) {
    class $ {
      constructor(due, credit) {
        var tmp;
        if (due === VOID) {
          // Inline function 'com.lightningkite.now' call
          var tmp_0 = get_default(Companion_instance).d1m();
          // Inline function 'kotlin.time.Companion.days' call
          Companion_getInstance();
          var tmp$ret$1 = toDuration(7, DurationUnit_DAYS_getInstance());
          tmp = tmp_0.u26(tmp$ret$1);
        } else {
          tmp = due;
        }
        due = tmp;
        credit = credit === VOID ? null : credit;
        this.j9f_1 = due;
        this.k9f_1 = credit;
      }
      z9e(history) {
        return withOptionalCredit('Remedy Plan', this.k9f_1);
      }
      a9f(history) {
        return 'Remedy Plan';
      }
      q9e(history) {
        return history.g8x();
      }
      p8z(due, credit) {
        return new (Remedy())(due, credit);
      }
      l9f(due, credit, $super) {
        due = due === VOID ? this.j9f_1 : due;
        credit = credit === VOID ? this.k9f_1 : credit;
        var tmp;
        if ($super === VOID) {
          tmp = this.p8z(due, credit);
        } else {
          var tmp_0 = $super.p8z;
          var tmp_1 = credit;
          tmp = tmp_0.call(this, due, tmp_1 == null ? null : new (MonetaryValue())(tmp_1));
        }
        return tmp;
      }
      toString() {
        var tmp = this.j9f_1.toString();
        var tmp_0 = this.k9f_1;
        return 'Remedy(due=' + tmp + ', credit=' + toString_0(tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) + ')';
      }
      hashCode() {
        var result = this.j9f_1.hashCode();
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.k9f_1;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = MonetaryValue__hashCode_impl_fhcsz2(this.k9f_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Remedy()))
          return false;
        if (!this.j9f_1.equals(other.j9f_1))
          return false;
        var tmp = this.k9f_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.k9f_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Remedy', Remedy, VOID, [DisputeResolution()]);
    RemedyClass = $;
  }
  return RemedyClass;
}
var HandledClass;
function Handled() {
  if (HandledClass === VOID) {
    class $ {
      constructor(credit) {
        credit = credit === VOID ? null : credit;
        this.m9f_1 = credit;
      }
      z9e(history) {
        return 'Handled';
      }
      q9e(history) {
        return history.g8x();
      }
      toString() {
        var tmp = this.m9f_1;
        return 'Handled(credit=' + toString_0(tmp == null ? null : new (MonetaryValue())(tmp)) + ')';
      }
      hashCode() {
        var tmp;
        var tmp_0 = this.m9f_1;
        if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
          tmp = 0;
        } else {
          tmp = MonetaryValue__hashCode_impl_fhcsz2(this.m9f_1);
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Handled()))
          return false;
        var tmp = this.m9f_1;
        var tmp_0 = tmp == null ? null : new (MonetaryValue())(tmp);
        var tmp_1 = other.m9f_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (MonetaryValue())(tmp_1)))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForClass($, 'Handled', Handled, VOID, [NeedsApproval()]);
    HandledClass = $;
  }
  return HandledClass;
}
var MoreInfoClass;
function MoreInfo() {
  if (MoreInfoClass === VOID) {
    class $ {
      z9e(history) {
        return 'More Info';
      }
      q9e(history) {
        return history.g8x();
      }
      toString() {
        return 'MoreInfo';
      }
      hashCode() {
        return 1443918803;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MoreInfo()))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForObject($, 'MoreInfo', VOID, VOID, [IncidentResponseType()]);
    MoreInfoClass = $;
  }
  return MoreInfoClass;
}
var MoreInfo_instance;
function MoreInfo_getInstance() {
  return MoreInfo_instance;
}
var AppealClass;
function Appeal() {
  if (AppealClass === VOID) {
    class $ {
      z9e(history) {
        return 'Appeal';
      }
      q9e(history) {
        return history.g8x();
      }
      toString() {
        return 'Appeal';
      }
      hashCode() {
        return -2084197441;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Appeal()))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForObject($, 'Appeal', VOID, VOID, [DisputeResolution()]);
    AppealClass = $;
  }
  return AppealClass;
}
var Appeal_instance;
function Appeal_getInstance() {
  return Appeal_instance;
}
var NotResponsibleClass;
function NotResponsible() {
  if (NotResponsibleClass === VOID) {
    class $ {
      z9e(history) {
        return 'Not Responsible';
      }
      q9e(history) {
        return history.g8x();
      }
      toString() {
        return 'NotResponsible';
      }
      hashCode() {
        return -484573101;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotResponsible()))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForObject($, 'NotResponsible', VOID, VOID, [DisputeResolution()]);
    NotResponsibleClass = $;
  }
  return NotResponsibleClass;
}
var NotResponsible_instance;
function NotResponsible_getInstance() {
  return NotResponsible_instance;
}
var RequestSiteVisitClass;
function RequestSiteVisit() {
  if (RequestSiteVisitClass === VOID) {
    class $ {
      constructor(time) {
        time = time === VOID ? null : time;
        this.n9f_1 = time;
      }
      z9e(history) {
        return 'Request Job Visit' + (!(this.n9f_1 == null) ? ' at ' + format(this.n9f_1, Formats_getInstance().k8z_1) : '');
      }
      a9f(history) {
        return 'Request Job Visit';
      }
      q9e(history) {
        return history.g8x();
      }
      toString() {
        return 'RequestSiteVisit(time=' + toString_0(this.n9f_1) + ')';
      }
      hashCode() {
        return this.n9f_1 == null ? 0 : this.n9f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestSiteVisit()))
          return false;
        if (!equals(this.n9f_1, other.n9f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestSiteVisit', RequestSiteVisit, VOID, [DisputeResolution()]);
    RequestSiteVisitClass = $;
  }
  return RequestSiteVisitClass;
}
var ContractorDisputeClass;
function ContractorDispute() {
  if (ContractorDisputeClass === VOID) {
    class $ {
      constructor(response) {
        this.b9f_1 = response;
      }
      z9e(history) {
        return this.b9f_1.z9e(history) + ' + Dispute';
      }
      a9f(history) {
        return this.b9f_1.a9f(history);
      }
      q9e(history) {
        return IncidentState_Disputed_getInstance();
      }
      toString() {
        return 'ContractorDispute(response=' + toString(this.b9f_1) + ')';
      }
      hashCode() {
        return hashCode(this.b9f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContractorDispute()))
          return false;
        if (!equals(this.b9f_1, other.b9f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ContractorDispute', VOID, VOID, [NeedsApproval()]);
    ContractorDisputeClass = $;
  }
  return ContractorDisputeClass;
}
var AcceptClass;
function Accept() {
  if (AcceptClass === VOID) {
    class $ {
      constructor(proposal, accessInfo) {
        this.o9e_1 = proposal;
        this.p9e_1 = accessInfo;
      }
      z9e(history) {
        var tmp;
        if (this.o9e_1 instanceof RequestSiteVisit()) {
          tmp = 'Confirm Visit';
        } else {
          tmp = 'Accept ' + this.o9e_1.z9e(history.j8x(this.p9e_1.q54_1));
        }
        return tmp;
      }
      q9e(history) {
        return resultantStateHubert$state(history, this.o9e_1);
      }
      o9f(proposal, accessInfo) {
        return new (Accept())(proposal, accessInfo);
      }
      p9f(proposal, accessInfo, $super) {
        proposal = proposal === VOID ? this.o9e_1 : proposal;
        accessInfo = accessInfo === VOID ? this.p9e_1 : accessInfo;
        return $super === VOID ? this.o9f(proposal, accessInfo) : $super.o9f.call(this, proposal, accessInfo);
      }
      toString() {
        return 'Accept(proposal=' + toString(this.o9e_1) + ', accessInfo=' + this.p9e_1.toString() + ')';
      }
      hashCode() {
        var result = hashCode(this.o9e_1);
        result = imul(result, 31) + this.p9e_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Accept()))
          return false;
        if (!equals(this.o9e_1, other.o9e_1))
          return false;
        if (!this.p9e_1.equals(other.p9e_1))
          return false;
        return true;
      }
    }
    protoOf($).a9f = shortDisplayNameHubert;
    initMetadataForClass($, 'Accept', VOID, VOID, [IncidentResponseType()]);
    AcceptClass = $;
  }
  return AcceptClass;
}
function shortDisplayNameHubert(history) {
  return this.z9e(history);
}
var IncidentResponseTypeClass;
function IncidentResponseType() {
  if (IncidentResponseTypeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'IncidentResponseType');
    IncidentResponseTypeClass = $;
  }
  return IncidentResponseTypeClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.f8q_1.f2();
}
function ClientConcern$Companion$_anonymous__6n5mi() {
  return createSimpleEnumSerializer('com.crowpay.incidentResponse.ClientConcern', values());
}
var ClientConcern_NoStart_instance;
var ClientConcern_Safety_instance;
var ClientConcern_CrewBehavior_instance;
var ClientConcern_SiteDamage_instance;
var ClientConcern_Communication_instance;
var ClientConcern_Other_instance;
function values() {
  return [ClientConcern_NoStart_getInstance(), ClientConcern_Safety_getInstance(), ClientConcern_CrewBehavior_getInstance(), ClientConcern_SiteDamage_getInstance(), ClientConcern_Communication_getInstance(), ClientConcern_Other_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.f8q_1 = lazy(tmp_0, ClientConcern$Companion$_anonymous__6n5mi);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  ClientConcern_initEntries();
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var ClientConcern_entriesInitialized;
function ClientConcern_initEntries() {
  if (ClientConcern_entriesInitialized)
    return Unit_instance;
  ClientConcern_entriesInitialized = true;
  ClientConcern_NoStart_instance = ClientConcern().q9f('NoStart', 0, 'No Start');
  ClientConcern_Safety_instance = ClientConcern().q9f('Safety', 1, 'Safety');
  ClientConcern_CrewBehavior_instance = ClientConcern().q9f('CrewBehavior', 2, 'Crew Behavior');
  ClientConcern_SiteDamage_instance = ClientConcern().q9f('SiteDamage', 3, 'Site Damage');
  ClientConcern_Communication_instance = ClientConcern().q9f('Communication', 4, 'Communication');
  ClientConcern_Other_instance = ClientConcern().q9f('Other', 5, 'Other');
  Companion_getInstance_0();
}
var $ENTRIES;
var ClientConcernClass;
function ClientConcern() {
  if (ClientConcernClass === VOID) {
    class $ extends Enum() {
      static q9f(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.e9f_1 = displayName;
        return $this;
      }
    }
    initMetadataForClass($, 'ClientConcern', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    ClientConcernClass = $;
  }
  return ClientConcernClass;
}
function get_isSignOff(_this__u8e3s4) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4 instanceof Handled()) {
    tmp_0 = true;
  } else {
    tmp_0 = _this__u8e3s4 instanceof RemedyHandled();
  }
  if (tmp_0) {
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function ClientConcern_NoStart_getInstance() {
  ClientConcern_initEntries();
  return ClientConcern_NoStart_instance;
}
function ClientConcern_Safety_getInstance() {
  ClientConcern_initEntries();
  return ClientConcern_Safety_instance;
}
function ClientConcern_CrewBehavior_getInstance() {
  ClientConcern_initEntries();
  return ClientConcern_CrewBehavior_instance;
}
function ClientConcern_SiteDamage_getInstance() {
  ClientConcern_initEntries();
  return ClientConcern_SiteDamage_instance;
}
function ClientConcern_Communication_getInstance() {
  ClientConcern_initEntries();
  return ClientConcern_Communication_instance;
}
function ClientConcern_Other_getInstance() {
  ClientConcern_initEntries();
  return ClientConcern_Other_instance;
}
//region block: init
MoreInfo_instance = new (MoreInfo())();
Appeal_instance = new (Appeal())();
NotResponsible_instance = new (NotResponsible())();
//endregion
//region block: exports
export {
  get_entries as get_entries1br0wi3ybq930,
  ClientConcern as ClientConcern1skfmbxl86a3t,
  Accept as Accept3c5lxev9vmal1,
  Appeal as Appealxiso3o25clbz,
  ClientResponse as ClientResponsexqxw1r0z235j,
  ContractorDispute as ContractorDisputefe9zenbw9zpq,
  Credit as Credit3h7kqwetoaiq0,
  DisputeResolution as DisputeResolution3thfkwxak0ppb,
  FileIncident as FileIncident88pwqv67k7mz,
  Handled as Handled19mgago2u0m72,
  MoreInfo as MoreInfo24u6wgs2qje82,
  NeedsApproval as NeedsApproval209x3ip39ndz6,
  NotResponsible as NotResponsible5sod6b685ij0,
  RemedyHandled as RemedyHandled1fest6c8tpi44,
  Remedy as Remedy2jczhqm350rbv,
  RequestSiteVisit as RequestSiteVisit2qqplegjmdj5x,
  get_isSignOff as get_isSignOff4lsphp4dtm8l,
  ClientConcern_Other_getInstance as ClientConcern_Other_getInstancezoo09lwnn20e,
  Companion_getInstance_0 as Companion_getInstance240fx64zw6f6d,
  Appeal_instance as Appeal_instance35tazwmyjzfwk,
  MoreInfo_instance as MoreInfo_instancelndi8wb3mxe1,
  NotResponsible_instance as NotResponsible_instance227dyeoudt4p,
};
//endregion

//# sourceMappingURL=IncidentResponseType.mjs.map
